<script setup lang="ts">
import { useCreditEvents, useCreditSimulator } from '~/composables/credit';

import { creditSimulatorButtonVariants } from '.';
import {
	CREDIT_INCOME_OPTIONS,
	CREDIT_INTENT_QUESTIONS,
	CREDIT_PRODUCT_NAMES
} from '../content';
import CreditSimulatorOptionGroup from './CreditSimulatorOptionGroup.vue';
import CreditSimulatorProgress from './CreditSimulatorProgress.vue';

const simulator = useCreditSimulator();
const creditEvents = useCreditEvents();
const state = simulator.state;
const intentQuestion = computed(
	() => CREDIT_INTENT_QUESTIONS[state.value.product]
);

const heading = useTemplateRef<HTMLElement>('heading');
defineExpose({ focusHeading: () => heading.value?.focus() });

function handleContinue() {
	creditEvents.trackQualification();
	simulator.next();
}
</script>

<template>
	<div class="flex flex-col gap-5.5">
		<CreditSimulatorProgress
			step-label="Passo 2 de 3"
			:detail="`${CREDIT_PRODUCT_NAMES[state.product]} · ${simulator.summaryAmount.value}`"
			progress-class="w-[66%]"
			:current-step="2"
		/>
		<div
			ref="heading"
			tabindex="-1"
			class="text-[20px] font-medium outline-none"
		>
			Conte um pouco mais sobre você
		</div>
		<CreditSimulatorOptionGroup
			:legend="intentQuestion.title"
			:options="intentQuestion.options"
			:selected="state.intent"
			@pick="simulator.answer('intent', $event)"
		/>
		<CreditSimulatorOptionGroup
			legend="Renda familiar mensal"
			:options="CREDIT_INCOME_OPTIONS"
			:selected="state.income"
			@pick="simulator.answer('income', $event)"
		/>
		<div class="flex gap-2.5">
			<button
				type="button"
				:class="creditSimulatorButtonVariants({ variant: 'back' })"
				@click="simulator.back()"
			>
				Voltar
			</button>
			<button
				type="button"
				:class="creditSimulatorButtonVariants({ variant: 'primary' })"
				@click="handleContinue"
			>
				Continuar
			</button>
		</div>
	</div>
</template>
